import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { Prefs } from "../../alias/prefs";
import { ExperimentSearchParameterKeys, noRevisionId } from "./url.types";
import { getExperiments } from "~/alias/uninstall";
export function createSafeOriginUrl(url) {
    const defaultOrigin = Prefs.get("ipm_default_origin");
    const safeOrigins = Prefs.get("ipm_safe_origins");
    let safeOriginUrl;
    try {
        safeOriginUrl = new URL(url, defaultOrigin);
    }
    catch (ex) {
        return null;
    }
    if (!safeOrigins.includes(safeOriginUrl.origin)) {
        return null;
    }
    return safeOriginUrl.href;
}
export async function addExperimentsSearchParams(url) {
    var _a;
    let extendedUrl;
    try {
        extendedUrl = new URL(url);
    }
    catch (ex) {
        return null;
    }
    extendedUrl.searchParams.append(ExperimentSearchParameterKeys.revision, (_a = (await ewe.experiments.getRevisionId())) !== null && _a !== void 0 ? _a : noRevisionId);
    extendedUrl.searchParams.append(ExperimentSearchParameterKeys.variants, await getExperiments());
    return extendedUrl.href;
}
